/**
 * Picks the viewer's copy from admin-authored text keyed by locale
 * (`{ 'en-us': …, 'es-mx': … }`), falling back to `en-us`. Blank entries count as
 * unset; null means no copy applies, so the caller shows its own default.
 */
export function resolveLocalizedText(
  texts: Partial<Record<string, string>> | null | undefined,
  locale: string
): string | null {
  return texts?.[locale.toLowerCase()]?.trim() || texts?.['en-us']?.trim() || null;
}
